<template>
    <div>
        <div class="org-tree-layout" v-if="showOrgTree">
            <swb-popover-org-tree :realComDefFirst="false" :multiSelect="true" :onlyShowRealCom="true" :costFlag="false" :prftFlag="false" :showMgmt="false" :bizDepart="false" :showIncludeSubComs="false" :initIncludeSubComs="false" @notity-change="checkComChange($event)"></swb-popover-org-tree>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler" :popupHandler="popupHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row" name="btns">
            <div class="left" v-if="formId != null">
                <a class="swb-btn swb-btn-small" @click="toPrint">打印</a>
            </div>
            <div class="right">
                <div v-if="checkActionPerm('export_rec')" class="swb-btn swb-btn-small swb-btn-primary" @click="exportAllAsExcel">
                    <span>导出</span>
                </div>
            </div>
        </div>

        <swb-result-table name="result_table" ref="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher, showPageRangeSelDlg } from '../../app.vues'

    import { getDefaultPageSizes, getDefaultDownloadPageSize } from '../../app.conf'
    import { checkUserActionPerm } from '../index'
    import { showGrpDownloadDlg, showDownloadDlg } from '../ctrl/dialog'
    import { loadAssetDeprMethodList } from '../retailer/asset-comn'
    import { showDevcCatSelectDlg } from '../categ/selectDlg'
    import { assetFiscalInfoDlg } from '../retailer/dialog'

    import assetFiscalApi from '../../api/assetFiscal';

    export default {
        name: 'swb-asset-depr-rec-list',
        path: '/asset/depr/rec/list/get',
        desc: '折旧记录',
        props: ["formId", "onlyQueryFailed"],
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                lastPageNumber: null,
                //
                confKey: 'swb-asset-depr-rec-list',
                theTableHeight: 590,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                //
                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 230,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                queryOnLoad: false,
                // 其他信息
                assetDeprRecList: [],
                exportFilter: {},
                assetTypeMap: {},
                deprMethodCodeMap: {},
                selectRealComIds: [],
                showOrgTree: false
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.assetTypeMap = getEnumMap("assetType", "value2text");
            this.deprMethodCodeMap = getEnumMap("assetDeprMethod", "name2text");
            if(Utils.isNoB(this.formId) || this.formId == -1) {
                this.btnColName = '';
                this.multiSelect = true;
                this.multiPageSelect = true;
                this.showOrgTree = true;
            }
        },
        mounted() {
            let self = this;
            if(!Utils.isNoB(self.formId)) {
                this.queryOnLoad = true;
                this.initResultTable();
                return;
            }
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //  根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.org-tree-layout, [name="query-sort-block"], [name="btns"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            // 实体公司切换
            checkComChange: function (eventDataList) {
                let realComIds = [];
                if(Array.isArray(eventDataList)) {
                    eventDataList = eventDataList || [];
                    for(let i = 0, len = eventDataList.length; i < len; i++) {
                        let eventData = eventDataList[i];
                        if(Utils.isTrue(eventData.realFlag)) {
                            this.realFlag = true;
                            realComIds.push(eventData.id);
                        }
                    }
                } else {
                    let eventData = eventDataList || {};
                    realComIds.push(eventData.id)
                }
                //
                this.selectRealComIds = Utils.merge([], realComIds);
            },
            onQueryConfigReady: function () {
                this.initAsyncQueryModel();
                //
                if(!Utils.isNoB(this.formId) && this.formId > 0) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let dataInfo = {};
                    dataInfo['hidden'] = true;
                    //
                    let deprFailedInfo = {};
                    deprFailedInfo["deprMonth"] = dataInfo;
                    query_model_ctrl.updateFields(deprFailedInfo);
                }
            },
            initAsyncQueryModel() {
                //
                if(Utils.isTrue(this.onlyQueryFailed)) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let dataInfo = {};
                    dataInfo['hidden'] = true;
                    //
                    let deprFailedInfo = {};
                    deprFailedInfo["deprFailed"] = dataInfo;
                    query_model_ctrl.updateFields(deprFailedInfo);
                }
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'devcInnerCode': function (row, colName, colValue, rowIndex, colConf) {
                        return '<a ref="#" class="table-cell-link">' + row.devcInnerCode + '</a>';
                    },
                    'fixedSpec': function (row, colName, colValue, rowIndex, colConf) {
                        if(Utils.isNoB(row.fixedSpec)) {
                            return '';
                        } else {
                            return "<span>" + row.fixedSpec + "</span>";
                        }
                    },
                    'assetTypeText': function (row, colName, colValue, rowIndex, colConf) {
                        if(!Utils.isNoB(row.assetType)) {
                            return '<span>' + self.assetTypeMap[row.assetType] + '</span>';
                        } else {
                            return "";
                        }
                    },
                    'deprMethodText': function (row, colName, colValue, rowIndex, colConf) {
                        if(!Utils.isNoB(row.deprMethodCode)) {
                            return '<span>' + self.deprMethodCodeMap[row.deprMethodCode] + '</span>';
                        } else {
                            return "";
                        }
                    },
                    // 累计折旧总和（针对批量）
                    'aggtDeprWorthSum': function (row, colName, colValue, rowIndex, colConf) {
                        if(!Utils.isNoB(row.aggtDeprWorth)) {
                            return '<span>' + (row.aggtDeprWorth * row.quantity).toFixed(2) + '</span>';
                        } else {
                            return "";
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'devcInnerCode': function (row, colName, colValue, rowIndex, btnName) {
                        self.viewAssetInfo(row)
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                    }
                });
            },
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                this.getAssetDeprRecList();
            },
            popupHandler: function (fieldCode, curValue, curText) {
                let self = this;
                if(fieldCode == 'innerDevcCatId') {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    showDevcCatSelectDlg({
                        filter: {
                            relSysFlag: true,
                            disabled: false,
                            level: 3
                        },
                    }, function (devcCat, theDlg) {
                        theDlg.close();
                        let devcCatId = devcCat.id;
                        let devcCatName = devcCat.name;
                        //
                        let fieldInfo = {
                            innerDevcCatId: {
                                value: devcCatId,
                                text: devcCatName
                            }
                        };
                        query_model_ctrl.updateFields(fieldInfo);
                    });
                }
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null;
                //
                this.getAssetDeprRecList();
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            getAssetDeprRecList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.assetFlag = 'comnAsset';
                if(!Utils.isNoB(self.formId) && self.formId > 0) {
                    filterItems.formId = self.formId;
                    filterItems.deprMonth = null;
                } else {
                    if(!Utils.isNoB(self.selectRealComIds)) {
                        filterItems.retailerRealComIds = self.selectRealComIds;
                    } else {
                        MsgBox.warning("请选择实体公司！");
                        return;
                    }
                }
                if(!Utils.isNoB(self.onlyQueryFailed) && Utils.isTrue(self.onlyQueryFailed)) {
                    filterItems.deprFailed = true;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                self.exportFilter = filterItems;
                //
                let theLoading = MsgBox.loading();
                // 调用查询接口
                assetFiscalApi.getAssetDeprRecPagedList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        self.assetDeprRecList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(self.assetDeprRecList, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            // 查看资产信息
            viewAssetInfo: function (row) {
                let params = {
                    innerCode: row.devcInnerCode,
                    assetType: row.assetType
                };
                assetFiscalInfoDlg(params);
            },
            exportAllAsExcel() {
                //
                if(this.totalCount <= 0) {
                    Toast.show("没有需要批量下载的文件", 5000, 'warning');
                    return;
                }
                //
                if((Utils.isNoB(this.formId) || this.formId == -1) && Utils.isNoB(this.selectRealComIds)) {
                    MsgBox.warning("请选择实体公司！");
                    return;
                }
                //
                let title = '折旧记录-下载';
                let fileName = '折旧记录-' + new Date().format('yyyy_MM_dd') + '.xlsx';
                let url = getAppUrl("/file/export/as/excel");
                let tableData = this.getTableData(null, null);
                let data = Utils.merge({
                    //指示要一次性单个文件全部导出（最大导出条数 受限于 系统参数 "Xls全量导出最大行数限制"）
                    exportAllAtOnce: true,
                    //指示分批请求数据条目数（每条字段数越大，此值应该越小，【可选】，默认取值（并受限）于系统参数 "Xls全量导出每批量数限制"）
                    // exportBatchSize: 500,
                    //
                    fileName: fileName
                }, tableData);
                let fileInfo = {
                    url: url,
                    post: true,
                    fileName: fileName,
                    data: data
                };
                showDownloadDlg(title, fileInfo);
            },
            // 导出
            doExport: function () {
                let self = this;
                let pageSize = getDefaultDownloadPageSize();
                let pages = Math.ceil(self.totalCount / 2000);
                if(pages > 10) {
                    showPageRangeSelDlg("选择导出文件序号", pages, 10, this.lastPageNumber, function (ok, range) {
                        if(ok) {
                            if(range.to == pages) {
                                self.lastPageNumber = 0;
                            } else {
                                self.lastPageNumber = range.to;
                            }
                            //
                            self.exportPrintData(pageSize, range.from, range.to);
                        }
                    }, {pageSize: pageSize})
                } else {
                    self.exportPrintData(pageSize);
                }
            },
            exportPrintData(pageSize, fromPages, toPages){
                let totalCount = this.totalCount;
                let pages = Math.ceil(totalCount / pageSize);
                //
                fromPages = fromPages == null ? 1 : fromPages;
                toPages = toPages == null ? pages : toPages;
                let tableData = this.getTableData(pages, pageSize);
                //
                let url = getAppUrl("/file/export/as/excel");
                let downloadUrls = [];
                for(let i = fromPages; i <= toPages; i++) {
                    let tmpFile = {};
                    tmpFile.url = url;
                    tmpFile.post = true;
                    tmpFile.fileName = "折旧记录" + (pages == 1 ? '' : ("_" + (i)));
                    tmpFile.seqNo = i;
                    //
                    let data = Utils.merge({}, tableData);
                    data.pageNumber = i;
                    data.fileName = tmpFile.fileName;
                    tmpFile.data = data;
                    downloadUrls.push(tmpFile);
                }
                let title = '折旧记录-下载| 每个文件' + pageSize + '条数据';
                showGrpDownloadDlg(title, downloadUrls);
            },
            getTableData(pages, pageSize){
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                //
                let rowsSrc = {};
                rowsSrc.data = this.getPostData();
                rowsSrc.url = "/asset/fiscal/asset/depr/rec/list/get";
                tableData.rowsSrc = rowsSrc;
                //
                tableData.pageSize = pageSize;
                tableData.pageCount = this.totalCount;
                tableData.pages = pages;
                return tableData;
            },
            getPostData(){
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportFilter);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            },
            toPrint(){
                let url = '/voucher/print/jsp';
                let postData = {
                    bizType: 'biz.proof.zichan.zhejiu',
                    voucherId: this.formId
                };
                let printUrl = Utils.makeUrl(getAppUrl(url), postData);
                Utils.setPageUrl(printUrl, '_blank');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/assetDepr/AssetDeprRecList.vue